module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list bomBill-page"
  }, [_c('list-head', {
    attrs: {
      "placeholder": "请输入BOM、成品进行搜索"
    },
    on: {
      "searchEmit": _vm.search
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      BOM清单管理\n      "), _c('span', {
    staticClass: "version"
  }, [_vm._v("公测版")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("此模块为测试版本，不属于现阶段收费范畴，期待与您进行需求共创！")])]), _vm._v(" "), _vm._l((_vm.topPermission), function(btn) {
    return _c('template', {
      slot: "options"
    }, [(btn === 'add') ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": _vm.addnew
      }
    }, [_vm._v(_vm._s(_vm.topMap[btn]))]) : _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.topBtnHandle(btn)
        }
      }
    }, [_vm._v(_vm._s(_vm.topMap[btn]))])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('list-panel', {
    ref: "panel",
    attrs: {
      "sortArray": _vm.sortArray,
      "belonger": _vm.belonger
    },
    on: {
      "ssChange": _vm.refreshTable,
      "refresh": _vm.getList
    }
  }), _vm._v(" "), _c('list-table', {
    ref: "table",
    attrs: {
      "summaryInfo": _vm.summaryInfo,
      "tableHead": _vm.listHead,
      "tableData": _vm.listData,
      "listMenu": _vm.hasListMenu
    },
    on: {
      "details": _vm.openDetail,
      "edit": _vm.editItem,
      "refresh": _vm.getList,
      "recall": _vm.handleRecall
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "foot-wrapper"
  }, [_c('list-footer', {
    ref: "foot",
    attrs: {
      "permission": _vm.botPermission
    },
    on: {
      "deleteArr": _vm.deleteRows,
      "cancelCheck": _vm.cancelTableCheck,
      "archived": _vm.handlePerm
    }
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.detailShow) ? _c('detail', {
    ref: "detail",
    attrs: {
      "id": _vm.detailId,
      "moduleName": _vm.popModel
    },
    on: {
      "addNew": _vm.newWorkFlow,
      "close": _vm.closeDetail,
      "refresh": _vm.getList,
      "edit": _vm.editItem,
      "recall": _vm.handleRecall
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.detailShow) ? _c('div', {
    staticClass: "detail-bg",
    on: {
      "click": function($event) {
        _vm.detailShow = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.choosePrintType) ? _c('Print', {
    attrs: {
      "entityIdProp": _vm.printIds,
      "moduleName": _vm.moduleName,
      "refType": _vm.refType
    },
    on: {
      "closeDialog": function($event) {
        _vm.choosePrintType = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.exportShow) ? _c('export', {
    on: {
      "export": _vm.exportFile,
      "closeDialog": _vm.closeExport
    }
  }) : _vm._e(), _vm._v(" "), (_vm.batchEditShow) ? _c('batch-edit', {
    attrs: {
      "selectIds": _vm.getSelectIds
    },
    on: {
      "refresh": _vm.success,
      "closeDialog": function($event) {
        _vm.batchEditShow = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e31ee09c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bom-bill/index.vue
// module id = 1347
// module chunks = 82